// extracted by mini-css-extract-plugin
export default {"wrapImgP":"ProdottoCheckout_wrapImgP__Izj1V","ImgP":"ProdottoCheckout_ImgP__Fe3mp"};